import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import { CopyMagicResultType } from 'common/components/CopyMagic/CopyMagic.types';

export const countResultCategoriesAndPosts = (result: CopyMagicResultType): number => {
  if (!result) return 0;
  return countResultCategories(result) + countResultPosts(result);
};

export const countResultCategories = (result: CopyMagicResultType): number => {
  if (!result) return 0;
  if (!('categories' in result)) return 0;

  return result.categories.length;
};

export const countResultPosts = (result: CopyMagicResultType): number => {
  if (!result) return 0;
  if (!('categories' in result)) return 0;

  return result.categories.reduce(
    (totalCount: number, { posts }: { posts: Array<any> }) => totalCount + posts.length,
    0,
  );
};

export const countResultCharacters = (result: CopyMagicResultType): number => {
  if (!result) return 0;
  if (!('categories' in result)) return 0;

  return concatCollectionStrings(result.categories).length;
};

export const countResultWords = (result: CopyMagicResultType): number => {
  if (!result) return 0;
  if (!('categories' in result)) return 0;

  return concatCollectionStrings(result.categories).split(' ').length;
};

const concatCollectionStrings = (collection: Array<any> | object): string => {
  const values = Array.isArray(collection) ? collection : Object.values(collection);
  const space = ' ';
  const trimDupSpace = (s: string) => s.replace(/\s+/g, space).trim();

  const totalString = values.reduce((accumulator: string, item) => {
    if (Array.isArray(item)) return accumulator.concat(space, concatCollectionStrings(item));
    if (isObject(item)) return accumulator.concat(space, concatCollectionStrings(item));
    if (isString(item)) return accumulator.concat(space, item);
    return accumulator;
  }, '');

  return trimDupSpace(totalString);
};
